import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { useFormContext } from '../context/form-context'

interface UseFormFieldProps {
  fieldSubentity: FormFieldInterface
}

export const useFormField = ({ fieldSubentity }: UseFormFieldProps) => {
  const {
    fieldsValues,
    fieldsErrors,
    setFieldsValues,
    setFieldsErrors,
    setCommonErrors,
  } = useFormContext()

  const slug = fieldSubentity.slug
  const value = fieldsValues[slug]

  return {
    value,
    onChange: (value: string | undefined) => {
      setFieldsValues({ ...fieldsValues, [slug]: value })
      setFieldsErrors({ ...fieldsErrors, [slug]: [] })
      setCommonErrors([])
    },
    errors: fieldsErrors[slug] || [],
  }
}
